<template>
  <div class="info-page">

    <b-container class="bv-example-row container-info-page">
        <b-row>
            <b-col cols="12" lg="6" md="12" sm="12">
              <div class="box-app-link text-center">
                <h1>THÀNH CÔNG</h1>

                <div class="app-play-store">
                  <p>Tải ứng dụng CCALL và trải nghiệm</p>
                  <a href="https://itunes.apple.com/us/app/ccall-softphone/id1386720616?ls=1&mt=8" target="_blank">
                    <img src="/static/apple-app-store.png" class="logo-ccall" width="190" />
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=vn.ccall.android" target="_blank">
                    <img src="/static/google-play.png" class="logo-ccall" width="200" />
                  </a>
                </div>

              </div>
            </b-col>

            <b-col cols="12" lg="6" md="12" sm="12">
              <div class="box-info-user">
                <h4>ĐĂNG KÝ THÀNH CÔNG</h4>
                <p>Chúc mừng bạn đã đăng ký thành công dịch vụ tổng đài CCALL</p>
                <p>Hãy trải nghiệm và dùng thử dịch vụ miễn phí</p>
                <p>Dưới đây là thông tin tổ chức của bạn:</p>
                <ul>
                  <li>
                    <span>Tên tổ chức</span>
                    <span>{{name}}</span>
                  </li>

                  <li>
                    <span>Số điện thoại</span>
                    <span>{{phone}}</span>
                  </li>

                  <li>
                    <span>Email</span>
                    <span>{{email}}</span>
                  </li>

                  <li>
                    <span>Trang quản trị</span>
                    <span>server.ccall.vn</span>
                  </li>

                  <!--
                  <li>
                    <span>Đầu số tổng đài</span>
                    <span>1900-0038</span>
                  </li>

                  <li>
                    <span>Hạn mức gọi ra</span>
                    <span>10.000 đ</span>
                  </li>

                  <li>
                    <span>Thời hạn sử dụng</span>
                    <span>04/06/2018</span>
                  </li>

                  <li>
                    <span>Số lượng người dùng</span>
                    <span>10 người dùng</span>
                  </li>
                  -->
                </ul>

                <a href="http://server.ccall.vn" target="_blank">
                <b-button variant="outline-warning lg" class="btn-advanced-setting">
                  THIẾT LẬP NÂNG CAO
                </b-button>
                </a>

              </div>

            </b-col>

        </b-row>
    </b-container>

  </div>


</template>

<script>
import BaseButton from "../components/Button.vue";

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
import bButton from 'bootstrap-vue/es/components/button/button';
import bButtonGroup from 'bootstrap-vue/es/components/button-group/button-group';
import bFormCheckboxGroup from 'bootstrap-vue/es/components/form-checkbox/form-checkbox-group';
import bFormCheckbox from 'bootstrap-vue/es/components/form-checkbox/form-checkbox';

import bContainer from 'bootstrap-vue/es/components/layout/container';
import bRow from 'bootstrap-vue/es/components/layout/row';
import bCol from 'bootstrap-vue/es/components/layout/col';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.component('b-modal', bModal);
Vue.directive('b-modal', bModalDirective);
Vue.component('b-button', bButton);
Vue.component('b-button-group', bButtonGroup);
Vue.component('b-form-checkbox-group', bFormCheckboxGroup);
Vue.component('b-form-checkbox', bFormCheckbox);

Vue.component('b-container', bContainer);
Vue.component('b-row', bRow);
Vue.component('b-col', bCol);

export default {
  components: {
    BaseButton,
  },
  name: 'InfoPage',
  props: {
    token: [Number, String],
  },
  data() {
    return {
      name: '',
      email: '',
      phone: '',
    };
  },
  methods: {
  },
  mounted() {
    if (this.token) {
      this.axios.get('/getData?token=' + this.token).then((response) => {
        if ((response.data.status)) {
          this.name = response.data.data.name;
          this.email = response.data.data.email;
          this.phone = response.data.data.phone;
        } else {
          this.$router.push({name: 'RegisterPage'});
        }
      });
    } else {
      this.$router.push({name: 'RegisterPage'});
    }
  }
};
</script>

<style scoped="">
  .btn-block {
    width: 80% !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/InfoPage.vue